<template>
    <div class="view pa24">
        <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
            :close-on-click-modal="false" :before-close="closeDialog">
            <el-form :model="ruleForm" ref="dealerRuleForm" label-width="100px" class="ruleForm">
                <el-form-item label="上传文件">
                    <el-upload ref="upload" class="upload-demo" :headers="upParams" drag :action="uploadUrl"
                        :on-exceed="handleExceed" :on-error="handleError" :on-success="handleSuccess" multiple
                        accept=".xls,.xlsx"  :on-remove="handleRemove">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <!-- 下载模板 -->
                <el-button @click="downloadTemplate">下载模板</el-button>
                <el-button @click="closeDialog">取 消</el-button>
                <el-button class="btncss" @click="confirmAddDealer">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { importExcel } from '@/api/companyManage.js'
    import CommUploadFile from "@/components/CommUploadFile.vue";
    export default {
        data() {
            let token = localStorage.getItem("token")
            return {
                fileList: [],
                upParams: {
                    token: token
                },
                uploadUrl: '/api/dealer/uploadExcel',
                dialogVisible: false,
                title: '数据导入',
                components: {
                    CommUploadFile
                },

                ruleForm: {
                    companyId: '',
                    file: null
                },
                rules: {
                },
                fileForm: ''
            };
        },
        onShow() {

        },
        methods: {
            openDialog(type, data, source) {
                this.ruleForm = {
                    companyId: '',
                    file: null
                };
                this.dialogVisible = true
                if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
            }
            },
            closeDialog() {
                this.dialogVisible = false
                this.$emit('getList')
            },
            downloadTemplate() {
                const templateUrl = '/file/经销商导入模板 .xlsx'
                const link = document.createElement('a');
                link.href = templateUrl;
                link.download = '经销商导入模板.xlsx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            // 上传文件
            handleSuccess(response, file, fileList) {
                console.log(file)
                if (response.code === 200) {
                    this.fileList = fileList
                    this.ruleForm.file = file.raw
                    this.ruleForm.fileForm = file.raw
                } else {
                    this.$message.error(response.message)
                    this.fileList = []
                }
            },
            handleError(err, file, fileList) {
                this.$message.error("导入失败")
            },
            handleExceed(files, fileList) {
                this.$message.warning("只能上传1个文件");
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            handleRemove(file, fileList) {
                this.ruleForm.fileForm = ''; // 清除已保存的文件对象}
                },
            beforeUpload(file) {
                // 允许上传的文件格式列表
                let acceptList = ["xlsx", "xls"]
                // 根据文件名获取文件的后缀名
                let fileType = file.name.split('.').pop().toLowerCase()
                // 判断文件格式是否符合要求
                if (acceptList.indexOf(fileType) === -1) {
                    this.$message.error('只能上传 xlsx/xls 格式的文件 !');
                    return false
                }
            },
            confirmAddDealer() {
                if (!this.ruleForm.fileForm) {
        this.$message.warning('请先上传文件');
        return;
    }
                // 构建params
                let formData = new FormData();
                formData.append('file', this.ruleForm.fileForm);
                importExcel(formData).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '设置成功'
                        })
                        this.closeDialog()
                    }
                })
            }
        }
    };

</script>

<style lang="scss" scoped>
    .ml10 {
        margin-left: 10 rpx;
    }
</style>